module.exports = __webpack_public_path__ + "img/avatar-01-120x120.409685d4.png";